<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { brand, navCtaText } from '../../config/pageData.js';
import { logEvent } from '@/utils/firebase.js';
import { getButtonUrl } from '@/utils/channelConfig.js';
import { getLogEventClickParams } from '@/utils/logEventParams';

const route = useRoute();
const ctaUrl = computed(() => getButtonUrl('topBtn', route.query.channel));
</script>

<template>
  <nav class="m-topbar">
    <div class="m-brand">
      <img
        :src="brand.logoLight"
        alt="楓燧堂"
        class="m-brand-logo"
      />
      <span class="m-brand-name">
        {{ brand.name }}
        <em>{{ brand.sub }}</em>
      </span>
    </div>
    <a
      :href="ctaUrl"
      target="_blank"
      rel="noopener noreferrer"
      class="m-topbar-btn"
      @click="logEvent('mobile_fengsuids_topbtn_click', getLogEventClickParams())"
    >
      {{ navCtaText }}
    </a>
  </nav>
</template>

<style scoped lang="scss">
.m-topbar {
  position: sticky;
  top: 0;
  z-index: 80;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 96px;
  padding: 0 28px;
  background: rgba(22, 36, 29, 0.96);
  backdrop-filter: blur(8px);
  border-bottom: 1px solid rgba(201, 162, 94, 0.2);
}

.m-brand {
  display: flex;
  align-items: center;
  gap: 12px;
}

.m-brand-logo {
  width: 56px;
  height: 56px;
}

.m-brand-name {
  font-size: 30px;
  font-weight: 700;
  letter-spacing: 3px;
  color: #f7f3ea;

  em {
    font-style: normal;
    color: #c9a25e;
  }
}

.m-topbar-btn {
  background: #c9a25e;
  color: #16241d;
  font-size: 24px;
  font-weight: 700;
  text-decoration: none;
  border-radius: 999px;
  padding: 12px 26px;
  white-space: nowrap;
}
</style>
